export default __webpack_public_path__ + "CircularCustCapNum-BookItalic.3b556b4c3cd08fb5f4c4174f8fdbe9e0.woff";